import { render, staticRenderFns } from "./GamanzaTournamentNotification.vue?vue&type=template&id=bddbb9c4&scoped=true"
import script from "./GamanzaTournamentNotification.vue?vue&type=script&lang=js"
export * from "./GamanzaTournamentNotification.vue?vue&type=script&lang=js"
import style0 from "./GamanzaTournamentNotification.vue?vue&type=style&index=0&id=bddbb9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddbb9c4",
  null
  
)

export default component.exports